"use client";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { fetch } from "libs";
import { PATCH_CHECKPOINT_AUTO_EXTEND } from "api";

interface UpdateModelAutoExtendParams {
  model_id: string;
  auto_extend: boolean;
  is_flux: boolean;
}

interface UpdateModelAutoExtendResponse {
  message: string;
  model_id: string;
  checkpoint_id?: string;
  auto_extend: boolean;
}

async function updateModelAutoExtend({
  model_id,
  auto_extend,
  is_flux,
}: UpdateModelAutoExtendParams): Promise<UpdateModelAutoExtendResponse> {
  // Using the updated endpoint pattern
  return fetch(`${PATCH_CHECKPOINT_AUTO_EXTEND}?model_id=${model_id}&auto_extend=${auto_extend}&is_flux=${is_flux}`, {
    method: "PATCH",
  });
}

// React Query hook
export function useUpdateModelAutoExtend() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateModelAutoExtend,
    onSuccess: (data, variables) => {
      // Invalidate queries that might be affected by this change
      queryClient.invalidateQueries({ 
        queryKey: ["useModel", variables.model_id] 
      });
      queryClient.invalidateQueries({ 
        queryKey: ["userModels"] 
      });
    },
  });
}

export default useUpdateModelAutoExtend;